// TODO: Remove this hook.

export const useDate = () => {
  const getDate = (date: string | Date, plusDays?: number) => {
    let current = new Date(date);
    current = plusDays ? new Date(current.setDate(current.getDate() + plusDays)) : current;
    const milliseconds = current.getMilliseconds();
    const seconds = current.getSeconds();
    const minutes = current.getMinutes();
    const hours = current.getHours();
    const timeAmPm = current.toLocaleString('en-US', { hour: 'numeric', hour12: true, minute: 'numeric' });
    const day: string | number = current.getDate();
    const dayString = day < 10 ? `0${day}` : day.toString();
    const month = current.getMonth();
    const monthString = month < 10 ? `0${month}` : month.toString();
    const fullmonth = current.toLocaleString('default', { month: 'long' });
    const shortmonth = current.toLocaleString('default', { month: 'short' });
    const year = current.getFullYear();
    const weekday = current.toLocaleString('default', { weekday: 'long' });
    const weekdayShort = current.toLocaleString('default', { weekday: 'short' });

    const past = current.getTime() <= new Date().getTime();
    const future = !past;

    const formattedDate = `${weekdayShort} ${shortmonth} ${day} ${year}, ${timeAmPm}`;

    return {
      milliseconds,
      seconds,
      minutes,
      hours,
      day,
      dayString,
      month,
      fullmonth,
      shortmonth,
      monthString,
      year,
      timeAmPm,
      weekday,
      formattedDate,
      past,
      future,
    };
  };

  return { getDate };
};
